import { Style } from '../../types'

export const encode = (input: any) => {
  return btoa(JSON.stringify(input))
}

export const buildConfig = (style: Partial<Style>) => {
  // TODO: include opt-in config
  return {
    styles: {
      colors: {
        primary: style.primary,
        secondary: style.secondary,
        tertiary: style.tertiary,
        accent: style.accent,
        border: style.borderColor,
      },
      layout: {
        padding: style.padding,
      }
    },
    variants: style.variants,
  }
}
